export const quiz = {
    
    questions: [
      {
        question: "What is the primary source of energy for the sun?",
        choices: ['Nuclear Fusion', 'Chemical Reactions', 'Fossil Fuels', 'Solar Panels'],
        type: 'MCQs',
        correctAnswer: 'Nuclear Fusion',
      },
      {
        question: "How does energy generated in the sun reach the Earth?",
        choices: [
          'Radiation',
          'Conduction',
          'Convection',
          'All of the above',
        ],
        type: 'MCQs',
        correctAnswer: 'Radiation',
      },
      {
        question: "What is the sun mainly composed of?",
        choices: [
          'Hydrogen',
          'Helium',
          'Carbon',
          'Oxygen',
        ],
        type: 'MCQs',
        correctAnswer: 'Hydrogen',
      },
      {
        question: "Which layer of the sun's atmosphere is visible during a solar eclipse?",
        choices: [
          'Photosphere',
          'Chromosphere',
          'Corona',
          'Core',
        ],
        type: 'MCQs',
        correctAnswer: 'Corona',
      },
      {
        question: "What causes the sun to shine?",
        choices: [
          'Nuclear Fission',
          'Gravity',
          'Solar Wind',
          'Nuclear Fusion',
        ],
        type: 'MCQs',
        correctAnswer: 'Nuclear Fusion',
      },
      {
        question: "How long does it take for sunlight to reach Earth?",
        choices: [
          '8 seconds',
          '8 minutes',
          '8 hours',
          '8 days',
        ],
        type: 'MCQs',
        correctAnswer: '8 minutes',
      },
      {
        question: "What is a solar flare?",
        choices: [
          'A sudden increase in solar energy production',
          'A burst of X-rays and particles from the sun',
          'A decrease in sunspot activity',
          'A solar eclipse',
        ],
        type: 'MCQs',
        correctAnswer: 'A burst of X-rays and particles from the sun',
      },
      {
        question: "Which spacecraft was the first to directly study the sun?",
        choices: [
          'Voyager 1',
          'Hubble Space Telescope',
          'Solar Dynamics Observatory (SDO)',
          'Parker Solar Probe',
        ],
        type: 'MCQs',
        correctAnswer: 'Parker Solar Probe',
      },
      {
        question: "What is the sun's approximate surface temperature?",
        choices: [
          '5,500 degrees Celsius',
          '10,000 degrees Celsius',
          '15 million degrees Celsius',
          '20,000 degrees Celsius',
        ],
        type: 'MCQs',
        correctAnswer: '5,500 degrees Celsius',
      },
      {
        question: "In Greek mythology, who is the solar god associated with the sun?",
        choices: ['Zeus', 'Apollo', 'Helios', 'Hermes'],
        type: 'MCQs',
        correctAnswer: 'Helios',
      },
      {
        question: "What is the boundary surrounding a black hole beyond which nothing can escape?",
      choices: ['Event Horizon', 'Singularity', 'Photon Sphere', 'Accretion Disk'],
      type: 'MCQs',
      correctAnswer: 'Event Horizon',
    },
    {
      question: "Who was the physicist that formulated the concept of a black hole?",
      choices: ['Albert Einstein', 'Stephen Hawking', 'Carl Sagan', 'John Wheeler'],
      type: 'MCQs',
      correctAnswer: 'John Wheeler',
    },
    {
      question: "What happens when an object crosses the event horizon of a black hole?",
      choices: [
        'It experiences extreme gravitational force',
        'It is torn apart by tidal forces',
        'It enters the black hole without noticeable effects',
        'It becomes invisible',
      ],
      type: 'MCQs',
      correctAnswer: 'It enters the black hole without noticeable effects',
    },
    {
      question: "What is the name of the supermassive black hole at the center of our galaxy?",
      choices: [
        'Sagittarius A*',
        'Alpha Centauri',
        'Epsilon Eridani',
        'VY Canis Majoris',
      ],
      type: 'MCQs',
      correctAnswer: 'Sagittarius A*',
    },
    {
      question: "What is the phenomenon where matter spirals into a black hole?",
      choices: [
        'Spaghettification',
        'Time Dilation',
        'Hawking Radiation',
        'Accretion',
      ],
      type: 'MCQs',
      correctAnswer: 'Accretion',
    },
    {
      question: "What is the name of the first-ever image of a black hole captured by scientists?",
      choices: [
        'M87*',
        'Cygnus X-1',
        'Sagittarius A*',
        'V404 Cygni',
      ],
      type: 'MCQs',
      correctAnswer: 'M87*',
    },
    {
      question: "Which force dominates inside a black hole?",
      choices: [
        'Electromagnetic Force',
        'Strong Nuclear Force',
        'Weak Nuclear Force',
        'Gravitational Force',
      ],
      type: 'MCQs',
      correctAnswer: 'Gravitational Force',
    },
    {
      question: "What is the maximum speed at which anything can escape a black hole?",
      choices: [
        'The Speed of Light',
        'Twice the Speed of Light',
        'Half the Speed of Light',
        'Depends on the black hole size',
      ],
      type: 'MCQs',
      correctAnswer: 'The Speed of Light',
    },
    {
      question: "What theory combines quantum mechanics and general relativity to explain black holes?",
      choices: [
        'String Theory',
        'Quantum Field Theory',
        'Loop Quantum Gravity',
        'M-Theory',
      ],
      type: 'MCQs',
      correctAnswer: 'String Theory',
    },
    {
      question: "What is the term used for the point of infinite density at the center of a black hole?",
      choices: [
        'Event Horizon',
        'Singularity',
        'White Hole',
        'Quasar',
      ],
      type: 'MCQs',
      correctAnswer: 'Singularity',
    },
    {
      question: "What is a shooting star?",
      choices: [
        'A meteor burning up in Earth’s atmosphere',
        'A star that falls from the sky',
        'A type of comet',
        'A satellite re-entering Earth’s atmosphere',
      ],
      type: 'MCQs',
      correctAnswer: 'A meteor burning up in Earth’s atmosphere',
    },
    {
      question: "What causes the bright streak of light seen during a shooting star?",
      choices: [
        'Friction with the atmosphere',
        'Collision with another celestial body',
        'Flaring of the star',
        'Ionization of the atmosphere',
      ],
      type: 'MCQs',
      correctAnswer: 'Friction with the atmosphere',
    },
    {
      question: "Which famous meteor shower occurs annually around mid-August?",
      choices: [
        'Perseids',
        'Leonids',
        'Orionids',
        'Geminids',
      ],
      type: 'MCQs',
      correctAnswer: 'Perseids',
    },
    {
      question: "What are the remnants of comets that burn up in Earth’s atmosphere?",
      choices: [
        'Meteoroids',
        'Asteroids',
        'Meteors',
        'Meteorites',
      ],
      type: 'MCQs',
      correctAnswer: 'Meteors',
    },
    {
      question: "Which famous comet is known for its periodic return approximately every 76 years?",
      choices: [
        'Hale-Bopp',
        'Halley’s Comet',
        'Comet ISON',
        'Comet Hyakutake',
      ],
      type: 'MCQs',
      correctAnswer: 'Halley’s Comet',
    },
    {
      question: "What is the visible trail of debris left behind by a comet called?",
      choices: [
        'Tail',
        'Comet Streak',
        'Debris Cloud',
        'Comet Stream',
      ],
      type: 'MCQs',
      correctAnswer: 'Tail',
    },
    {
      question: "What is the scientific name for the study of meteors and meteor showers?",
      choices: [
        'Meteorology',
        'Meteoritics',
        'Meteorosophy',
        'Meteorography',
      ],
      type: 'MCQs',
      correctAnswer: 'Meteoritics',
    },
    {
      question: "What is the largest known comet in our solar system?",
      choices: [
        'Comet Halley',
        'Comet Lovejoy',
        'Comet Hale-Bopp',
        'Comet McNaught',
      ],
      type: 'MCQs',
      correctAnswer: 'Comet Hale-Bopp',
    },
    {
      question: "What do scientists believe causes the tail of a comet to point away from the sun?",
      choices: [
        'Gravitational Pull',
        'Solar Wind',
        'Magnetic Field of the Sun',
        'Friction with Space Dust',
      ],
      type: 'MCQs',
      correctAnswer: 'Solar Wind',
    },
    {
      question: "What was the first comet to be visited by a spacecraft from Earth?",
      choices: [
        'Comet Borrelly',
        'Comet Halley',
        'Comet Wild 2',
        'Comet 67P/Churyumov-Gerasimenko',
      ],
      type: 'MCQs',
      correctAnswer: 'Comet Halley',
    },
    {
      question: "What type of galaxy is the Milky Way?",
      choices: [
        'Spiral Galaxy',
        'Elliptical Galaxy',
        'Irregular Galaxy',
        'Dwarf Galaxy',
      ],
      type: 'MCQs',
      correctAnswer: 'Spiral Galaxy',
    },
    {
      question: "What is the approximate number of stars in the Milky Way?",
      choices: [
        '100,000',
        '1 million',
        '100 million',
        '100 billion',
      ],
      type: 'MCQs',
      correctAnswer: '100 billion',
    },
    {
      question: "What is the name of the supermassive black hole at the center of the Milky Way?",
      choices: [
        'Sagittarius A*',
        'Alpha Centauri A',
        'Andromeda',
        'Proxima Centauri',
      ],
      type: 'MCQs',
      correctAnswer: 'Sagittarius A*',
    },
    {
      question: "Which component of the Milky Way contains most of its mass?",
      choices: [
        'Dark Matter',
        'Interstellar Gas',
        'Stellar Remnants',
        'Planetary Systems',
      ],
      type: 'MCQs',
      correctAnswer: 'Dark Matter',
    },
    {
      question: "What is the name of the group of stars that the Sun belongs to in the Milky Way?",
      choices: [
        'Orion Arm',
        'Sagittarius Arm',
        'Perseus Arm',
        'Local Arm',
      ],
      type: 'MCQs',
      correctAnswer: 'Orion Arm',
    },
    {
      question: "Which astronomer first described the nature of the Milky Way as a collection of stars?",
      choices: [
        'Ptolemy',
        'Galileo Galilei',
        'Isaac Newton',
        'William Herschel',
      ],
      type: 'MCQs',
      correctAnswer: 'Galileo Galilei',
    },
    {
      question: "What is the name of the satellite launched to map the Milky Way in unprecedented detail?",
      choices: [
        'Spitzer Space Telescope',
        'Kepler Space Telescope',
        'Gaia Space Observatory',
        'Hubble Space Telescope',
      ],
      type: 'MCQs',
      correctAnswer: 'Gaia Space Observatory',
    },
    {
      question: "What is the diameter of the Milky Way?",
      choices: [
        '100,000 light-years',
        '1 million light-years',
        '100 million light-years',
        '100 billion light-years',
      ],
      type: 'MCQs',
      correctAnswer: '100,000 light-years',
    },
    {
      question: "What process contributes to the formation of new stars in the Milky Way?",
      choices: [
        'Nuclear Fusion',
        'Supernova Explosions',
        'Star Collision',
        'All of the above',
      ],
      type: 'MCQs',
      correctAnswer: 'All of the above',
    },
    {
      question: "What is the age of the Milky Way?",
      choices: [
        '4.5 billion years',
        '10 billion years',
        '13.8 billion years',
        '20 billion years',
      ],
      type: 'MCQs',
      correctAnswer: '13.8 billion years',
    },
    {
      question: "What is Jupiter's largest moon?",
      choices: [
        'Ganymede',
        'Europa',
        'Io',
        'Callisto',
      ],
      type: 'MCQs',
      correctAnswer: 'Ganymede',
    },
    {
      question: "Which gas makes up the majority of Jupiter's atmosphere?",
      choices: [
        'Hydrogen',
        'Oxygen',
        'Carbon Dioxide',
        'Methane',
      ],
      type: 'MCQs',
      correctAnswer: 'Hydrogen',
    },
    {
      question: "What causes Jupiter's colorful bands and zones?",
      choices: [
        'Clouds of different compositions',
        'Underlying oceans',
        'Magnetic fields',
        'Volcanic activity',
      ],
      type: 'MCQs',
      correctAnswer: 'Clouds of different compositions',
    },
    {
      question: "What is the Great Red Spot on Jupiter?",
      choices: [
        'A giant storm',
        'A desert',
        'A volcanic crater',
        'An ice cap',
      ],
      type: 'MCQs',
      correctAnswer: 'A giant storm',
    },
    {
      question: "What is the name of Jupiter's faint ring system?",
      choices: [
        'Halo',
        'Aurora',
        'Main Ring',
        'Gossamer Ring',
      ],
      type: 'MCQs',
      correctAnswer: 'Gossamer Ring',
    },
    {
      question: "Jupiter radiates more energy into space than it receives from the Sun. True or False?",
      choices: [
        'True',
        'False',
      ],
      type: 'MCQs',
      correctAnswer: 'True',
    },
    {
      question: "What is the approximate diameter of Jupiter?",
      choices: [
        '139,822 kilometers',
        '231,532 kilometers',
        '50,724 kilometers',
        '342,443 kilometers',
      ],
      type: 'MCQs',
      correctAnswer: '139,822 kilometers',
    },
    {
      question: "Who discovered Jupiter's four largest moons known as the Galilean moons?",
      choices: [
        'Johannes Kepler',
        'Galileo Galilei',
        'Nicolaus Copernicus',
        'Isaac Newton',
      ],
      type: 'MCQs',
      correctAnswer: 'Galileo Galilei',
    },
    {
      question: "Jupiter is often referred to as a 'failed star.' Why?",
      choices: [
        'Because it is smaller than a star',
        'Because it is made of gas',
        'Because it could not sustain nuclear fusion',
        'Because it has a weak magnetic field',
      ],
      type: 'MCQs',
      correctAnswer: 'Because it could not sustain nuclear fusion',
    },
    {
      question: "What is the primary component of Jupiter's core?",
      choices: [
        'Iron',
        'Rock',
        'Metallic Hydrogen',
        'Diamond',
      ],
      type: 'MCQs',
      correctAnswer: 'Metallic Hydrogen',
    },
    {
      question: "What is the initial stage of a star's life cycle?",
      choices: [
        'Protostar',
        'Red Giant',
        'Supernova',
        'White Dwarf',
      ],
      type: 'MCQs',
      correctAnswer: 'Protostar',
    },
    {
      question: "What process leads to the formation of a star?",
      choices: [
        'Nuclear Fusion',
        'Nuclear Fission',
        'Radioactive Decay',
        'Chemical Bonding',
      ],
      type: 'MCQs',
      correctAnswer: 'Nuclear Fusion',
    },
    {
      question: "What type of stars are formed by the collapse of massive gas clouds?",
      choices: [
        'Main Sequence Stars',
        'Red Dwarfs',
        'Blue Giants',
        'Supergiants',
      ],
      type: 'MCQs',
      correctAnswer: 'Supergiants',
    },
    {
      question: "What is the final stage in the life cycle of a high-mass star?",
      choices: [
        'Supernova',
        'Black Hole',
        'Neutron Star',
        'White Dwarf',
      ],
      type: 'MCQs',
      correctAnswer: 'Supernova',
    },
    {
      question: "Which element is primarily formed in the core of a massive star during nuclear fusion?",
      choices: [
        'Iron',
        'Helium',
        'Hydrogen',
        'Carbon',
      ],
      type: 'MCQs',
      correctAnswer: 'Iron',
    },
    {
      question: "What type of star fuses helium into heavier elements after exhausting its hydrogen fuel?",
      choices: [
        'Red Giant',
        'White Dwarf',
        'Blue Supergiant',
        'Protostar',
      ],
      type: 'MCQs',
      correctAnswer: 'Red Giant',
    },
    {
      question: "What happens to a star after it exhausts its nuclear fuel?",
      choices: [
        'Expands into a red giant or supergiant',
        'Shrinks into a white dwarf',
        'Undergoes a supernova explosion',
        'All of the above',
      ],
      type: 'MCQs',
      correctAnswer: 'All of the above',
    },
    {
      question: "What is the remnant left after a high-mass star undergoes a supernova explosion?",
      choices: [
        'Black Hole',
        'Neutron Star',
        'White Dwarf',
        'Pulsar',
      ],
      type: 'MCQs',
      correctAnswer: 'Neutron Star',
    },
    {
      question: "What happens to a low-mass star after it becomes a white dwarf?",
      choices: [
        'It cools down and fades away',
        'It explodes as a supernova',
        'It collapses into a black hole',
        'It becomes a neutron star',
      ],
      type: 'MCQs',
      correctAnswer: 'It cools down and fades away',
    },
    {
      question: "What stage marks the end of a star's life cycle as a luminous object?",
      choices: [
        'Black Dwarf',
        'Black Hole',
        'Neutron Star',
        'White Dwarf',
      ],
      type: 'MCQs',
      correctAnswer: 'Black Dwarf',
    },
    {
      question: "What theory revolutionized our understanding of gravity by proposing that mass warps spacetime?",
      choices: [
        'Quantum Mechanics',
        'General Relativity',
        'String Theory',
        'Special Relativity',
      ],
      type: 'MCQs',
      correctAnswer: 'General Relativity',
    },
    {
      question: "Who formulated the theory of general relativity?",
      choices: [
        'Isaac Newton',
        'Albert Einstein',
        'Stephen Hawking',
        'Galileo Galilei',
      ],
      type: 'MCQs',
      correctAnswer: 'Albert Einstein',
    },
    {
      question: "What term describes the warping of spacetime caused by massive objects?",
      choices: [
        'Time Dilation',
        'Gravitational Lensing',
        'Higgs Field',
        'Dark Matter',
      ],
      type: 'MCQs',
      correctAnswer: 'Gravitational Lensing',
    },
    {
      question: "What phenomenon occurs when two massive objects distort spacetime, causing ripples called gravitational waves?",
      choices: [
        'Black Hole Singularity',
        'Quantum Entanglement',
        'Cosmic Inflation',
        'Binary Neutron Star Merger',
      ],
      type: 'MCQs',
      correctAnswer: 'Binary Neutron Star Merger',
    },
    {
      question: "Which concept suggests that the gravity near a black hole is so strong that nothing, not even light, can escape its gravitational pull?",
      choices: [
        'Event Horizon',
        'Wormhole',
        'Singularity',
        'Escape Velocity',
      ],
      type: 'MCQs',
      correctAnswer: 'Event Horizon',
    },
    {
      question: "What is the name of the spacecraft launched to detect gravitational waves?",
      choices: [
        'Hubble Space Telescope',
        'LIGO (Laser Interferometer Gravitational-Wave Observatory)',
        'Voyager Spacecraft',
        'Mars Curiosity Rover',
      ],
      type: 'MCQs',
      correctAnswer: 'LIGO (Laser Interferometer Gravitational-Wave Observatory)',
    },
    {
      question: "What effect results from time passing more slowly in a gravitational field?",
      choices: [
        'Time Dilation',
        'Length Contraction',
        'Tidal Forces',
        'Gravitational Redshift',
      ],
      type: 'MCQs',
      correctAnswer: 'Time Dilation',
    },
    {
      question: "In Einstein's field equations of general relativity, what symbol represents the curvature of spacetime?",
      choices: [
        'R',
        'G',
        'T',
        'Λ',
      ],
      type: 'MCQs',
      correctAnswer: 'R',
    },
    {
      question: "What does the term 'geodesic' refer to in general relativity?",
      choices: [
        'Space Deformation',
        'Light Paths',
        'Gravitational Waves',
        'Curved Time',
      ],
      type: 'MCQs',
      correctAnswer: 'Light Paths',
    },
    {
      question: "What phenomenon arises from the bending of light around massive objects due to gravitational effects?",
      choices: [
        'Gravitational Redshift',
        'Event Horizon',
        'Frame Dragging',
        'Gravitational Lensing',
      ],
      type: 'MCQs',
      correctAnswer: 'Gravitational Lensing',
    },
    {
      question: "During a solar eclipse, what celestial event occurs?",
      choices: [
        'The Moon passes between the Sun and Earth',
        'The Earth passes between the Sun and Moon',
        'The Sun passes between the Earth and Moon',
        'The Moon is in its new moon phase',
      ],
      type: 'MCQs',
      correctAnswer: 'The Moon passes between the Sun and Earth',
    },
    {
      question: "What phase is the Moon in during a lunar eclipse?",
      choices: [
        'Full Moon',
        'New Moon',
        'Waxing Crescent',
        'Waning Gibbous',
      ],
      type: 'MCQs',
      correctAnswer: 'Full Moon',
    },
    {
      question: "Why don't we have a solar eclipse every month?",
      choices: [
        'The Moon\'s orbit is inclined relative to Earths orbit',
        'The Moon\'s shadow is too small',
        'The Earth\'s atmosphere blocks it',
        'The Sun\'s brightness prevents it',
      ],
      type: 'MCQs',
      correctAnswer: 'The Moon\'s orbit is inclined relative to Earth’s orbit',
    },
    {
      question: "Which type of eclipse occurs when the Earth is directly between the Sun and the Moon?",
      choices: [
        'Lunar Eclipse',
        'Solar Eclipse',
        'Annular Eclipse',
        'Partial Eclipse',
      ],
      type: 'MCQs',
      correctAnswer: 'Lunar Eclipse',
    },
    {
      question: "What is the name of the faint, outer part of a total solar eclipse's shadow?",
      choices: [
        'Penumbra',
        'Antumbra',
        'Umbra',
        'Corona',
      ],
      type: 'MCQs',
      correctAnswer: 'Penumbra',
    },
    {
      question: "During a lunar eclipse, why does the Moon appear reddish in color?",
      choices: [
        'Due to the refraction of sunlight through Earths atmosphere',
        'Because of the Moons surface composition',
        'The Moon reflects red light from the Sun',
        'A change in the Moons internal temperature',
      ],
      type: 'MCQs',
      correctAnswer: 'Due to the refraction of sunlight through Earths atmosphere',
    },
    {
      question: "Which type of eclipse occurs when the Moon passes directly in front of the Sun but doesnt cover the entire solar disc?",
      choices: [
        'Annular Eclipse',
        'Total Eclipse',
        'Partial Eclipse',
        'Hybrid Eclipse',
      ],
      type: 'MCQs',
      correctAnswer: 'Annular Eclipse',
    },
    {
      question: "What is the darkest part of the Moon's shadow during a solar eclipse?",
      choices: [
        'Penumbra',
        'Antumbra',
        'Umbra',
        'Corona',
      ],
      type: 'MCQs',
      correctAnswer: 'Umbra',
    },
    {
      question: "What is the term for the rare occurrence when a solar eclipse and a lunar eclipse happen on the same day?",
      choices: [
        'Dual Eclipse',
        'Co-Eclipse',
        'Syzygy',
        'Ecliptic Convergence',
      ],
      type: 'MCQs',
      correctAnswer: 'Syzygy',
    },
    {
      question: "What is the approximate duration of a total solar eclipse from the beginning to the end?",
      choices: [
        'A few hours',
        'Less than an hour',
        'Several minutes',
        'Around half a day',
      ],
      type: 'MCQs',
      correctAnswer: 'Several minutes',
    },
    {
      question: "What process powers the Sun and other stars, converting hydrogen into helium?",
      choices: [
        'Nuclear Fission',
        'Nuclear Fusion',
        'Radioactive Decay',
        'Chemical Bonding',
      ],
      type: 'MCQs',
      correctAnswer: 'Nuclear Fusion',
    },
    {
      question: "At which stage of a star's life cycle does hydrogen fusion occur?",
      choices: [
        'Protostar',
        'Red Giant',
        'Main Sequence',
        'White Dwarf',
      ],
      type: 'MCQs',
      correctAnswer: 'Main Sequence',
    },
    {
      question: "Which element is formed as a result of nuclear fusion in the core of a star?",
      choices: [
        'Helium',
        'Carbon',
        'Oxygen',
        'All of the above',
      ],
      type: 'MCQs',
      correctAnswer: 'Helium',
    },
    {
      question: "What is the temperature required for nuclear fusion to occur in a star?",
      choices: [
        '100,000°C',
        '1 million°C',
        '10 million°C',
        '100 million°C',
      ],
      type: 'MCQs',
      correctAnswer: '10 million°C',
    },
    {
      question: "Which stage follows the fusion of helium into heavier elements in a massive star?",
      choices: [
        'Red Dwarf',
        'Red Giant',
        'Supernova',
        'White Dwarf',
      ],
      type: 'MCQs',
      correctAnswer: 'Red Giant',
    },
    {
      question: "What happens when the core of a massive star runs out of nuclear fuel?",
      choices: [
        'It collapses and forms a black hole',
        'It expands into a red giant',
        'It undergoes a supernova explosion',
        'It forms a neutron star',
      ],
      type: 'MCQs',
      correctAnswer: 'It undergoes a supernova explosion',
    },
    {
      question: "What is the fusion process that occurs in stars heavier than the Sun?",
      choices: [
        'Triple-alpha process',
        'Carbon-nitrogen-oxygen cycle',
        'CNO cycle',
        'Helium capture',
      ],
      type: 'MCQs',
      correctAnswer: 'CNO cycle',
    },
    {
      question: "Which part of a star's structure is responsible for nuclear fusion?",
      choices: [
        'Core',
        'Radiative Zone',
        'Convective Zone',
        'Photosphere',
      ],
      type: 'MCQs',
      correctAnswer: 'Core',
    },
    {
      question: "What is the energy released from nuclear fusion in stars primarily in the form of?",
      choices: [
        'Heat and Light',
        'Sound Waves',
        'Gamma Rays',
        'Electromagnetic Fields',
      ],
      type: 'MCQs',
      correctAnswer: 'Heat and Light',
    },
    {
      question: "What is the term for the balancing act in a star where gravity compresses while fusion generates outward pressure?",
      choices: [
        'Hydrostatic Equilibrium',
        'Thermal Equilibrium',
        'Nuclear Equilibrium',
        'Stellar Equilibrium',
      ],
      type: 'MCQs',
      correctAnswer: 'Hydrostatic Equilibrium',
    },
    ],
  };